<template>
    <div class="staff-members">
        <div ref="scrolled-element" class="tab-pane active no-print">
            <div v-if="staffMembersFromAA.length > 0 || activeForm === FORMS.ADD" class="table-wrapper">
                <!-- TODO remove the second v-if? -->
                <table
                    v-if="staffMembersFromAA.length > 0 || activeForm === FORMS.ADD"
                    v-show="!searchKeyword || staffMembersFromAA.length > 0 || activeForm === FORMS.ADD"
                    id="forAT_table-StaffMembers"
                    class="common-table staff-table"
                >
                    <thead>
                        <tr class="tbl-header">
                            <th>{{ $t('staff.membersTab.table.columns.assignable') }}</th>
                            <th>{{ $t('staff.membersTab.table.columns.name') }}</th>
                            <th>{{ $t('staff.membersTab.table.columns.login') }}</th>
                            <th>{{ $t('staff.membersTab.table.columns.number') }}</th>
                            <th>{{ $t('staff.membersTab.table.columns.card') }}</th>
                            <th>{{ $t('staff.membersTab.table.columns.access') }}</th>
                            <th>{{ $t('staff.membersTab.table.columns.comments') }}</th>
                            <th>{{ $t('staff.membersTab.table.columns.actions') }}</th>
                        </tr>
                    </thead>
                    <!-- row to create new staff -->
                    <StaffRow
                        v-if="activeForm === FORMS.ADD"
                        ref="staff-row-add"
                        :access-module-options="accessModuleOptions"
                        :all-staff-members="allStaffMembers"
                        :all-staff-groups="allStaffGroups"
                        :message-group-options="messageGroupOptions"
                        :portable-device-options="portableDeviceOptions"
                        :is-form-active="isFormActive"
                        :on-save="saveStaff"
                        :on-close="closeForm"
                        :on-edit-another-staff="editAnotherStaff"
                    />

                    <!-- rows contain staff members from current assignment area -->
                    <StaffRow
                        v-for="staff in displayedStaffMembers"
                        :key="staff.user_id"
                        :ref="`staff-row-${staff.user_id}`"
                        :staff-member="staff"
                        :access-module-options="accessModuleOptions"
                        :all-staff-members="allStaffMembers"
                        :all-staff-groups="allStaffGroups"
                        :message-group-options="messageGroupOptions"
                        :portable-device-options="portableDeviceOptions"
                        :is-form-active="isFormActive"
                        :on-save="saveStaff"
                        :on-close="closeForm"
                        :on-remove="deleteStaff"
                        :on-edit-staff="onEditStaff"
                        :on-edit-another-staff="editAnotherStaff"
                        @scroll-to-edited-staff="srollToEditedStaff"
                    />
                </table>
                <h3
                    v-if="searchKeyword && displayedStaffMembers.length === 0"
                    v-text="$t('common.searchNoResult', { val: searchKeyword })"
                ></h3>
            </div>
            <div v-else class="data-empty no-print">
                <h3 v-if="dataLoaded" v-text="$t('staff.membersTab.noSuperUsers')"></h3>
            </div>
        </div>
        <div class="print-only">
            <h4
                v-if="searchKeyword && filteredStaffMembers.length > 0"
                v-text="$t('print.search', { val: searchKeyword })"
            ></h4>
            <table
                v-if="staffMembersFromAA.length > 0"
                id="forAT_table-StaffMembers-print"
                class="table print-staff-members"
            >
                <thead>
                    <tr class="tbl-header">
                        <th>{{ $t('staff.membersTab.table.columns.assignable') }}</th>
                        <th>{{ $t('staff.membersTab.table.columns.name') }}</th>
                        <th>{{ $t('staff.membersTab.table.columns.login') }}</th>
                        <th>{{ $t('staff.membersTab.table.columns.number') }}</th>
                        <th>{{ $t('staff.membersTab.table.columns.card') }}</th>
                        <th>{{ $t('staff.membersTab.table.columns.access') }}</th>
                        <th>{{ $t('staff.membersTab.table.columns.comments') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="staff in staffMembersInPrint" :key="staff.user_id">
                        <td><i v-if="staff.assignable" class="icon-checkmark"></i></td>
                        <td v-text="staff.first_name"></td>
                        <td><i v-if="staff.login_name" class="icon-checkmark"></i></td>
                        <td v-text="staff.call_id"></td>
                        <td v-text="staff.card_id"></td>
                        <td>
                            <span
                                v-for="accessModule in staff.accessModules"
                                :key="accessModule.value"
                                class="access-module"
                                v-text="accessModule.name"
                            ></span>
                        </td>
                        <td v-text="staff.comment"></td>
                    </tr>
                </tbody>
            </table>
            <h3 v-else class="data-empty" v-text="$t('staff.membersTab.noSuperUsers')"></h3>
        </div>
        <Pagination
            v-show="pagination.last_page > 1"
            v-model="pagination.current_page"
            class="no-print"
            :options="pagination"
            :callback="onChangePaginationPage"
            :unsaved-callback="unsavedCallback"
        />
    </div>
</template>

<script type="text/babel">
import { mapState, mapActions, mapMutations } from 'vuex';
import orderBy from 'lodash-es/orderBy';
import sortBy from 'lodash-es/sortBy';
import StaffRow from './staff/StaffRow';
import staffUtils, { getEmptyStaffMember, updateStaffMembers } from './staff/staffUtils';
import mappingState from './common/mappingState';
import Pagination from './common/Pagination';
import { errorHandler, unsavedHandler, ifIsNotCanceled } from './common/helpers';
import {
    ROUTE_NAMES,
    STAFF_MEMBERS_NAVIGATION_NUMBER,
    SUCCESS,
    USER_TYPES,
    KEYS,
    CARD_LEVEL_ANONYMOUS_VALUE,
} from '../constants';
import {
    resourceStaffMember,
    resourceStaffMembers,
    resourceMsgGroups,
    resourceAccessModules,
    resourcePortableDevices,
} from '../api/resources';
import { getCancelToken } from '../api';

const FORMS = {
    ADD: 1,
    EDIT: 2,
    EDIT_ANOTHER: 3,
};

export default {
    name: 'SuperUsers',

    components: {
        StaffRow,
        Pagination,
    },

    mixins: [staffUtils, mappingState],

    constants: {
        FORMS,
    },

    data() {
        return {
            allStaffMembers: [], // from whole system
            staffMembersFromAA: [], // from current AA
            filteredStaffMembers: [], // filtered staff members by search
            // displayedStaffMembers: [], // displayed staff members
            activeForm: null,
            currentUser: null,
            editingStaffMember: null,
            messagingGroups: [],
            messageGroupOptions: [],
            allAccessModules: [],
            portableDevices: [],
            portableDeviceOptions: [],
            emptyLabel: '',
            dataLoaded: false,
            isValid: false,
            cancelToken: getCancelToken(),
            pagination: {
                current_page: 1,
                last_page: 0,
                per_page: STAFF_MEMBERS_NAVIGATION_NUMBER,
            },
            scrolledElement: null,
        };
    },

    computed: {
        ...mapState({
            allAssignmentAreas: 'assignmentArea',
            unsavedChanges: 'unsavedChanges',
        }),

        paginationLastPage() {
            return Math.ceil(this.filteredStaffMembers.length / STAFF_MEMBERS_NAVIGATION_NUMBER);
        },

        staffMembersInPrint() {
            if (this.filteredStaffMembers.length > 0) {
                return this.filteredStaffMembers;
            }

            return this.staffMembersFromAA;
        },

        displayedStaffMembers() {
            let currentPage = this.pagination.current_page;

            let start = Math.max((currentPage - 1) * STAFF_MEMBERS_NAVIGATION_NUMBER, 0);
            let end = currentPage * STAFF_MEMBERS_NAVIGATION_NUMBER;

            return this.filteredStaffMembers.slice(start, end);
        },

        isFormActive() {
            return Object.values(FORMS).includes(this.activeForm);
        },

        accessModuleOptions() {
            if (Array.isArray(this.allAccessModules)) {
                return this.allAccessModules.map(item => ({
                    value: item.peripheral_id,
                    name: item.name,
                }));
            }

            return [];
        },

        searchEnabled() {
            return this.staffMembersFromAA.length > 0;
        },
    },

    watch: {
        searchKeyword() {
            this.refreshFilteredStaffMembers();
        },

        filteredStaffMembers(staffList) {
            const lastPage = Math.ceil(staffList.length / STAFF_MEMBERS_NAVIGATION_NUMBER);
            this.pagination.last_page = lastPage;
        },

        paginationLastPage(val) {
            this.pagination.last_page = val;
        },

        searchEnabled(val) {
            this.setSearchEnabled(val);

            if (!val) {
                this.setKeyword('');
            }
        },
    },

    created() {
        this.configButton({
            buttonName: 'addButton',
            action: () => {
                this.activeForm = FORMS.ADD;
                this.setSearchBlocked(true);
                this.scrolledElement.scrollTop = 0;
            },
            disabled: () => this.isFormActive || this.allAssignmentAreas.length === 0,
        });
        this.updateData(() => {
            this.closeForm();
            return this.loadData();
        });
        this.loadData();
    },

    mounted() {
        this.$nextTick(() => {
            // Here, after elements were created, we can access this.$refs
            this.scrolledElement = this.$refs['scrolled-element'];
        });

        this.addOnKeyDownHandler({
            handlerName: this.$options.name,
            handler: event => {
                if (
                    event.which === KEYS.ESC &&
                    this.isFormActive &&
                    !document.body.classList.contains('modal-open')
                ) {
                    this.unsavedCallback();
                }
            },
        });
    },

    beforeDestroy() {
        this.setSearchBlocked(false);
        this.cancelToken.cancel();
        this.removeOnKeyDownHandler(this.$options.name);
    },

    methods: {
        ...mapActions({
            setFirstName: 'user/setFirstName',
            addOnKeyDownHandler: 'addOnKeyDownHandler',
            removeOnKeyDownHandler: 'removeOnKeyDownHandler',
        }),
        ...mapMutations({ updateData: 'SET_UPDATE_DATA' }),

        onChangePaginationPage() {
            // empty function
        },

        unsavedCallback() {
            return new Promise(resolve => {
                let confirmMessage = {
                    confirmBody: this.$t('common.confirmCancelChangesBody'),
                };
                if (this.activeForm === FORMS.ADD) {
                    let staffRowAdd = this.$refs['staff-row-add'];

                    if (this.unsavedChanges) {
                        return unsavedHandler(confirmMessage)
                            .then(() => {
                                staffRowAdd.closeClick();
                                resolve();
                            })
                            .catch(() => {});
                    }

                    staffRowAdd.closeClick();
                    resolve();
                } else {
                    this.displayedStaffMembers.forEach(staff => {
                        let row = this.$refs[`staff-row-${staff.user_id}`];
                        if (row && row[0] && row[0].staffMember.editing) {
                            if (this.unsavedChanges) {
                                return unsavedHandler(confirmMessage)
                                    .then(() => {
                                        row[0].closeClick();
                                        resolve();
                                    })
                                    .catch(() => {});
                            }
                            row[0].closeClick();
                            resolve();
                        }
                    });
                }
                if (!this.unsavedChanges) {
                    resolve();
                }
            });
        },

        buildStaffMemberList(list) {
            this.allStaffMembers = list.reduce((allStaff, item) => {
                // skip developers
                if (item.type === USER_TYPES.DEVELOPER) {
                    return allStaff;
                }

                let staff = {
                    ...getEmptyStaffMember(),
                    ...item,
                };

                if (staff.type === USER_TYPES.SUPER_USER) {
                    staff.message_group_id = staff.call_id;
                }

                if (!Array.isArray(staff.areas)) {
                    staff.areas = [];
                }

                staff.isAAPrimary = true;

                staff.accessModules = this.getAccessModulesForUser(staff.card_access);
                staff.card_access = Array.isArray(staff.card_access) ? staff.card_access : [];
                staff.card_action = staff.card_action || CARD_LEVEL_ANONYMOUS_VALUE;

                if (staff.isAAPrimary || staff.type === USER_TYPES.SUPER_USER) {
                    staff.assigned = staff.used_in_assignments;
                    staff.assignedGroupNames = this.getAssignedGroupNames(staff.user_id);
                    staff.userIsInAssignedGroup = this.isUserInAssignedGroup(staff.user_id);

                    staff.userIsLastAssignableInAssignedGroup = this.isLastAssignableUserInAssignedGroup(
                        staff.user_id
                    );

                    staff.staffGroups = this.getGroupsWithUser(staff.user_id);
                }

                return allStaff.concat(staff);
            }, []);

            let staffMembersFromAA = this.allStaffMembers.filter(staff => {
                // skip all staff except super users
                if (staff.type !== USER_TYPES.SUPER_USER) {
                    return false;
                }

                staff.fromCurrentAA = true;

                return true;
            });

            this.staffMembersFromAA = sortBy(staffMembersFromAA, 'first_name');
        },

        refreshFilteredStaffMembers() {
            let staffList = this.filterStaffMembers(this.staffMembersFromAA, this.searchKeyword);

            if (staffList.length !== this.filteredStaffMembers.length) {
                // change page if the list changed
                this.pagination.current_page = 1;
            }
            // Add the edit user in filtered staff list
            if (this.activeForm !== null && this.currentUser !== null) {
                if (!staffList.find(s => s.user_id === this.currentUser.user_id)) {
                    staffList.unshift(this.currentUser);
                }
            }
            this.filteredStaffMembers = staffList;
        },

        filterStaffMembers(list, keyword) {
            if (keyword) {
                return list.filter(item => {
                    let firstName = item.first_name.toLowerCase().includes(keyword);
                    let callId = (item.call_id || '').toLowerCase().includes(keyword);
                    let cardId = (item.card_id || '').toLowerCase().includes(keyword);
                    let comment = (item.comment || '').toLowerCase().includes(keyword);

                    let cardAccess = item.card_access.some(access => {
                        return this.allAccessModules.some(module => {
                            let peripheralId = module.peripheral_id === access;
                            let assignmentAreaId = module.assignmentarea_id === this.userAreaId;
                            let moduleName = module.name.toLowerCase().includes(keyword);

                            return peripheralId && assignmentAreaId && moduleName;
                        });
                    });

                    return firstName || callId || cardId || comment || cardAccess;
                });
            }

            // copy array but not objects in the array
            return [].concat(list);
        },

        loadData() {
            this.showLoading(true);

            return Promise.all([
                this.loadStaffMembersList(), // result[0]
                this.loadStaffGroupsList(),
                this.loadAccessModules(),
                this.loadPortableDevices(),
            ])
                .then(result => {
                    let staffMembers = result[0];

                    this.buildStaffMemberList(staffMembers);
                    this.refreshFilteredStaffMembers();

                    this.dataLoaded = true;
                    this.showLoading(false);
                })
                .catch(
                    ifIsNotCanceled({
                        callback: response => {
                            errorHandler(response.status, ROUTE_NAMES.STAFF__MEMBERS);
                        },
                    })
                );
        },

        closeForm() {
            let isAnotherStaff = this.activeForm === FORMS.EDIT_ANOTHER;

            this.activeForm = null;
            this.editingStaffMember = null;
            this.currentUser = null;
            this.setSearchBlocked(false);
            this.setUnsavedChanges(false);

            if (isAnotherStaff) {
                this.refreshFilteredStaffMembers();
            }
        },

        getPaginationPageOfStaff(staff) {
            let staffIndex = this.filteredStaffMembers.findIndex(s => {
                return s.user_id === staff.user_id;
            });

            if (staffIndex === -1) {
                return 1;
            }

            return Math.floor(staffIndex / STAFF_MEMBERS_NAVIGATION_NUMBER) + 1;
        },

        getStaffById(staffId) {
            return this.allStaffMembers.find(staff => {
                return staff.user_id === staffId;
            });
        },

        isUserAdmin(userType) {
            return userType === USER_TYPES.USER_ADMIN || userType === USER_TYPES.SUPER_USER;
        },

        isActionDisabled(userType, userId) {
            return (
                userType === USER_TYPES.SUPER_USER &&
                (userId !== this.userId || this.userType !== USER_TYPES.SUPER_USER)
            );
        },

        getAccessModulesForUser(cardAccess) {
            if (Array.isArray(cardAccess)) {
                return cardAccess
                    .filter(accessId => {
                        return this.allAccessModules.some(access => {
                            return access.peripheral_id === accessId;
                        });
                    })
                    .map(itemId => ({
                        value: itemId,
                        name: this.allAccessModules
                            .filter(item => item.peripheral_id === itemId)
                            .map(module => module.name)
                            .shift(),
                    }));
            }

            return [];
        },

        loadAccessModules() {
            return resourceAccessModules({
                cancelToken: this.cancelToken.token,
            }).then(response => {
                this.allAccessModules = response.data || [];
            });
        },

        loadMessagingGroups() {
            return resourceMsgGroups({
                id: this.userAreaId,
                cancelToken: this.cancelToken.token,
            }).then(response => {
                this.messagingGroups = response.data || [];
                this.setMessageGroupOptions();
            });
        },

        loadStaffMembersList() {
            return resourceStaffMembers({ cancelToken: this.cancelToken.token })
                .then(response => {
                    return Array.isArray(response.data) ? updateStaffMembers(response.data) : [];
                })
                .catch(response => {
                    return Promise.reject(response);
                });
        },

        loadPortableDevices() {
            return resourcePortableDevices({
                cancelToken: this.cancelToken.token,
            })
                .then(response => {
                    this.portableDevices = response.data || [];
                    this.setPortableDevicesOptions();
                })
                .catch(response => {
                    this.setPortableDevicesOptions();
                    return Promise.reject(response);
                });
        },

        takeAwayCard(majorStaff) {
            let cardId = majorStaff.card_id;

            if (cardId) {
                this.allStaffMembers.forEach(staff => {
                    if (staff.card_id === cardId && staff.user_id !== majorStaff.user_id) {
                        staff.card_id = null;
                        staff.card_action = CARD_LEVEL_ANONYMOUS_VALUE;
                        staff.card_access = [];
                        staff.accessModules = [];
                        this.$nextTick(() => {
                            let staffRow = this.$refs[`staff-row-${staff.user_id}`];
                            if (Array.isArray(staffRow) && staffRow.length > 0) {
                                staffRow[0].updateStaff();
                            }
                        });
                    }
                });
            }
        },

        /**
         * @param {Object} staff
         * @returns {Promise}
         */
        saveStaff(staff) {
            if (!this.unsavedChanges) {
                return;
            }

            this.showLoading(true);

            if (this.activeForm === FORMS.ADD) {
                return this.saveNewStaff(staff)
                    .then(user_id => {
                        staff.user_id = user_id;
                        staff.fromCurrentAA = true;
                        staff.editing = false;
                        staff.call_id = staff.message_group_id;
                        staff.user_type = USER_TYPES.SUPER_USER;

                        this.allStaffMembers.push(staff);
                        this.takeAwayCard(staff);
                        this.staffMembersFromAA = sortBy(this.staffMembersFromAA.concat(staff), 'first_name');

                        this.closeForm();
                        this.refreshFilteredStaffMembers();
                        this.setUnsavedChanges(false);
                        this.showLoading(false);

                        this.popup({
                            type: SUCCESS,
                            header: this.$t('common.success'),
                            text: this.$t('common.saved'),
                        });
                    })
                    .catch(
                        ifIsNotCanceled({
                            reject: true,
                            callback: response => {
                                if ([400, 403, 404, 409].includes(response.status)) {
                                    return this.loadData().then(() => Promise.reject());
                                }
                            },
                        })
                    );
            }

            let data = {
                card_id: staff.card_id,
                card_action: staff.card_id ? staff.card_action : CARD_LEVEL_ANONYMOUS_VALUE,
                card_access: staff.card_id ? staff.accessModules.map(module => module.value) : [],
            };

            if (staff.isAAPrimary) {
                data.first_name = staff.first_name.trim();
                data.assignable = staff.assignable;
                data.comment = staff.comment.trim();
                data.message_group_id = staff.message_group_id;
                data.user_type = staff.type;

                if (staff.login_name && staff.password) {
                    data.login_name = staff.login_name;
                    data.password = staff.password;
                }
            }

            return resourceStaffMember({
                method: 'post',
                id: staff.user_id,
                data: JSON.stringify(data),
            })
                .then(() => {
                    if (staff.type === USER_TYPES.SUPER_USER) {
                        staff.call_id = data.message_group_id;
                    } else {
                        staff.call_id = this.getCallIdByMessageGroupId(data.message_group_id);
                    }

                    staff.card_action = data.card_action;
                    staff.card_access = data.card_access;
                    staff.accessModules = this.getAccessModulesForUser(staff.card_access);

                    this.replaceStaffInList(this.allStaffMembers, staff);
                    this.updateStaffGroupsWithStaff(staff);
                    this.takeAwayCard(staff);
                    this.buildStaffMemberList(this.allStaffMembers);

                    this.closeForm();
                    this.refreshFilteredStaffMembers();
                    this.showLoading(false);

                    this.popup({
                        type: SUCCESS,
                        header: this.$t('common.success'),
                        text: this.$t('common.saved'),
                    });
                })
                .catch(
                    ifIsNotCanceled({
                        reject: true,
                        callback: response => {
                            if ([400, 403, 404, 409].includes(response.status)) {
                                return this.loadData().then(() => {
                                    if (response.status === 404) {
                                        this.closeForm();
                                    }
                                    // Promise.reject doesn't allow to close Edit form
                                    return Promise.reject();
                                });
                            }
                        },
                    })
                );
        },

        saveNewStaff(staff) {
            const data = {
                first_name: staff.first_name,
                last_name: staff.last_name,
                login_name: staff.login_name || null,
                assignable: staff.assignable,
                password: staff.login_name ? staff.password : null,
                assignmentarea_id: this.userAreaId, // current assignment area id
                card_access: staff.accessModules.map(item => item.value),
                card_action: staff.card_action,
                card_id: staff.card_id,
                comment: staff.comment,
                language: 'English (US)',
                message_group_id: staff.message_group_id,
                user_type: USER_TYPES.SUPER_USER,
            };

            return resourceStaffMember({
                method: 'post',
                data: JSON.stringify(data),
            }).then(response => response.data.user_id);
        },

        /**
         * update list of staff groups to detect last assignable staff with number in assigned group
         * @param {Object} staff
         */
        updateStaffGroupsWithStaff(staff) {
            staff.staffGroups.forEach(staffGroup => {
                this.updateStaffInGroup(staffGroup, staff);
            });
        },

        setMessageGroupOptions() {
            let noMessageGroupOption = [
                {
                    value: null,
                    name: this.$t('staff.membersTab.noPhoneNumber'),
                },
            ];
            let messageGroupOptions = this.messagingGroups.map(item => ({
                value: item.message_group_id,
                name: `${item.name} (${item.call_id})`,
            }));
            this.messageGroupOptions = noMessageGroupOption.concat(orderBy(messageGroupOptions, 'name'));
        },

        /**
         * get call id by message group id from common list
         * @param {number} messageGroupId
         * @returns {number|null} callId
         */
        getCallIdByMessageGroupId(messageGroupId) {
            let messageGroup = this.messagingGroups.find(messageGroup => {
                return messageGroup.message_group_id === messageGroupId;
            });

            if (messageGroup) {
                return messageGroup.call_id;
            }

            return null;
        },

        setPortableDevicesOptions() {
            let noPortbleDevicesOption = [
                {
                    value: null,
                    name: this.$t('staff.membersTab.noPhoneNumber'),
                },
            ];
            let portbleDevicesOption = this.portableDevices.map(item => ({
                value: item.call_id,
                name: item.call_id,
            }));
            this.portableDeviceOptions = noPortbleDevicesOption.concat(orderBy(portbleDevicesOption, 'name'));
        },

        /**
         * update staff in list
         * @returns {Boolean}
         */
        replaceStaffInList(list, staff) {
            let staffIndex = list.findIndex(s => {
                return s.user_id === staff.user_id;
            });

            if (staffIndex !== -1) {
                list.splice(staffIndex, 1, staff);
                return true;
            }

            return false;
        },

        /**
         * remove staff from list
         * @returns {Boolean}
         */
        removeStaffFromList(list, staff) {
            let staffIndex = list.findIndex(s => {
                return s.user_id === staff.user_id;
            });

            if (staffIndex !== -1) {
                list.splice(staffIndex, 1);
                return true;
            }

            return false;
        },

        /**
         * clears access modules and removes card_access from current AA
         * @returns {Object} cleared staff
         */
        clearAccessModules(staff) {
            let cardAccessFromCurrentAA = this.allAccessModules.reduce((cards, item) => {
                if (item.assignmentarea_id === this.userAreaId) {
                    return cards.concat(item.peripheral_id);
                }

                return cards;
            }, []);

            let cardAccessFromAnotherAA = staff.card_access.filter(oneCardAccess => {
                return !cardAccessFromCurrentAA.includes(oneCardAccess);
            });

            return {
                ...staff,
                accessModules: [],
                card_access: cardAccessFromAnotherAA,
            };
        },

        deleteStaff(staff) {
            // Generate message for confirm dialog
            let confirmation = [
                this.$t('staff.membersTab.removeStaffMember', {
                    name: staff.first_name,
                }),
            ];
            let groupsWithUser = this.getGroupNamesWithUser(staff.user_id);

            if (groupsWithUser.length > 0) {
                confirmation.push(
                    this.$t('staff.membersTab.removeStaffFromGroups', {
                        groups: groupsWithUser.join(', '),
                    })
                );
            }
            if (staff.assigned) {
                confirmation.push(this.$t('staff.membersTab.removeStaffFromAssignments'));
            }

            confirmation.push(this.$t('staff.membersTab.areYouSure'));

            return this.confirmation({
                confirmTitle: this.$t('staff.membersTab.removingStaff'),
                confirmBody: confirmation,
            })
                .then(confirm => {
                    if (!confirm) {
                        return Promise.reject('canceled');
                    }

                    this.showLoading(true);

                    return resourceStaffMember({
                        method: 'delete',
                        id: staff.user_id,
                    });
                })
                .then(() => {
                    // replace in AllStaffMembers list to have uniq names in the system
                    this.removeStaffFromList(this.allStaffMembers, staff);

                    // remove from displayed list
                    this.removeStaffFromList(this.staffMembersFromAA, staff);

                    staff.staffGroups.forEach(staffGroup => {
                        this.removeStaffMemberFromStaffGroup(staffGroup.groupId, staff.user_id);
                    });

                    this.buildStaffMemberList(this.allStaffMembers);
                    this.refreshFilteredStaffMembers();

                    this.showLoading(false);
                })
                .catch(error => {
                    ifIsNotCanceled({
                        showPopUp: !(
                            error &&
                            error.status === 404 &&
                            error.config &&
                            error.config.method === 'delete'
                        ),
                        callback: error => {
                            if (error.status === 404) {
                                return this.loadData();
                            }
                        },
                    })(error);
                });
        },

        /**
         * called when user opens edit form
         */
        onEditStaff() {
            this.setSearchBlocked(true);
            this.activeForm = FORMS.EDIT;
        },

        editAnotherStaff(staffId) {
            let staff = this.getStaffById(staffId);
            this.currentUser = staff;
            this.refreshFilteredStaffMembers();

            this.activeForm = null;

            setTimeout(() => {
                this.setUnsavedChanges(false);
                staff.editing = true;
                this.activeForm = FORMS.EDIT_ANOTHER;
                let paginationPage = this.getPaginationPageOfStaff(staff);

                this.pagination.current_page = paginationPage;
            }, 100); // TODO remove setTimeout
        },

        /**
         * scrolls as many rows as above the edited staff
         */
        srollToEditedStaff(staffMember) {
            this.$nextTick(() => {
                let index = this.filteredStaffMembers.findIndex(
                    staff => staff.user_id === staffMember.user_id
                );
                let indexInTable = index % STAFF_MEMBERS_NAVIGATION_NUMBER;
                let firstIndexInTable = index - indexInTable;
                let idOfFirstStaffInTable = this.filteredStaffMembers[firstIndexInTable].user_id;
                let row = this.$refs[`staff-row-${idOfFirstStaffInTable}`];
                let rowHeight = row[0].$el.getBoundingClientRect().height;
                this.scrolledElement.scrollTop = indexInTable * rowHeight;
            });
        },
    },
};
</script>
